import * as React from "react";
import * as R from "ramda";
import {Field} from "react-final-form";
import {connect} from "react-redux";
import {Uen} from "../modelo/Uen";

class UenActivas extends React.Component<UenActivasProps> {

    render() {
        const {className, uenActivas} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {uenActivas && uenActivas.map((uen: Uen) => {
                                return <option key={uen.codigo} value={uen.codigo}>{uen.codigo} - {uen.nombre}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface UenActivasProps {
    name: string,
    className?: string,
    uenActivas?: Array<Uen>
}

export default connect((store: any, props: any) => {
    return {
        ...props,
        uenActivas: R.pathOr([], ["maestros", "uenActivas"])(store)
    };
})(UenActivas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/UenActivas.tsx